import { render, staticRenderFns } from "./getContentView.vue?vue&type=template&id=20a3aecf&scoped=true&"
import script from "./getContentView.vue?vue&type=script&lang=js&"
export * from "./getContentView.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3aecf",
  null
  
)

export default component.exports